import OrganizationGeneral from "../views/OrganizationGeneral.vue";

const menu = [];

const routes = [
  {
    path: "/myorganisation",
    name: "myorganisation",
    component: OrganizationGeneral,
    meta: {
      forAuth: true,
    },
  },
];

export default { menu, routes };
